// extracted by mini-css-extract-plugin
export default {"bankModalList":"BankModalList_bankModalList__YF-MO"};